// removed by extract-text-webpack-plugin
module.exports = {"docList":"_3-7AmDT8a9J9gyRPGHZk2X","playlist":"_11YXkD5s4eFYxsrAJsK4z0","itemAuthor":"_1GRczwqAtL7SRz2CvANXvz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocList/DocList.scss
// module id = 818
// module chunks = 0